import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import { useSeo } from "@/hooks/useSeo";
import { articles, faqs, siteDesc, trendingList } from "@/mocks/news";
import HeroSection from "./components/HeroSection";
import BreakingTicker from "./components/BreakingTicker";
import TrendingPanel from "./components/TrendingPanel";
import CategoryShowcase from "./components/CategoryShowcase";
import LiveFeed from "./components/LiveFeed";
import FaqSection from "./components/FaqSection";
import SubscribeForm from "./components/SubscribeForm";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "沸点爆料",
    description: siteDesc,
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "沸点爆料",
    description: "聚合娱乐爆料、社会热点与科技快讯的中文内容门户。",
    email: "tip@feidian-kuaixun.example",
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "今日热榜",
    itemListElement: trendingList.map((item) => ({
      "@type": "ListItem",
      position: item.rank,
      name: item.title,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: { "@type": "Answer", text: faq.a },
    })),
  },
];

export default function Home() {
  const location = useLocation();

  useSeo({
    title: "热点爆料今日快讯_热点爆料最新持续更新 - 沸点爆料",
    description: siteDesc,
    keywords: "热点爆料,热点爆料今日,热点爆料快讯,热点爆料最新,热点爆料持续更新",
    path: "/",
    ogType: "website",
    jsonLd: homeJsonLd,
  });

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const usedIds = [1, 2, 4];
  const latest = articles.filter((a) => !usedIds.includes(a.id)).slice(0, 6);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />

      <main className="flex-1 w-full">
        <HeroSection />
        <BreakingTicker />

        <div className="w-full px-4 md:px-6 py-10 md:py-14 flex flex-col gap-14 md:gap-20">
          <section aria-label="头条爆料" className="w-full">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
              <div className="lg:col-span-8 flex flex-col gap-5">
                <ArticleCard article={articles[0]} variant="feature" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <ArticleCard article={articles[1]} />
                  <ArticleCard article={articles[3]} />
                </div>
              </div>
              <div id="trending" className="lg:col-span-4 scroll-mt-24">
                <TrendingPanel />
              </div>
            </div>
          </section>

          <section aria-label="内容频道">
            <SectionHeading
              eyebrow="内容频道"
              title="按兴趣挑选你的爆料频道"
              desc="娱乐、社会、科技、生活、体坛与财经，六个频道各管一摊，想看什么直接进。"
            />
            <CategoryShowcase />
          </section>

          <section aria-label="最新爆料">
            <SectionHeading
              eyebrow="最新爆料"
              title="刚刚更新的爆料内容"
              desc="按更新时间排列，越靠前越新鲜。重要事件的后续进展会回到原文持续更新。"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {latest.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          <LiveFeed />

          <FaqSection />

          <SubscribeForm />
        </div>
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}